// extracted by mini-css-extract-plugin
export default {"fileCardContainer":"styles_fileCardContainer__hUVaf","imgFile":"styles_imgFile__Elc+x"};